import { useTheme } from "@mui/material";
import { FC } from "react";
import { CartesianGrid } from "recharts";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { GRID_LINE_HEIGHT } from "../LineChart";

export const LineChartGrid: FC = () => {
  const theme = useTheme();
  const isMobile = useIsMobile();

  return (
    <CartesianGrid
      height={isMobile ? undefined : GRID_LINE_HEIGHT}
      stroke={theme.colors.secondary[1]}
      style={{ backgroundColor: theme.colors.red }}
      vertical={true}
    />
  );
};
